import { Injectable } from '@angular/core';
import { App } from '@df/core/app';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { DfModalService } from '@df/ui/modal/df-modal.service';

@Injectable()
export abstract class AbstractDfModalInitiatorService<D = any> {
    constructor(
        protected dfModalService: DfModalService,
        protected app: App
    ) {}

    /**
     * Public method that sets up listener for a particular modal
     */
    initiate(modal: NDfModal.IConfig): Promise<void> {
        return new Promise(resolve => {
            let isOpening = false;
            this.listen(data => {
                // show that open is triggered so that we know not to close the promise yet
                isOpening = true;
                this.open(modal, undefined, data)
                    .catch(() => {})
                    .finally(() => {
                        // only resolve if opening, otherwise its already resolved
                        if (isOpening) {
                            resolve();
                        }
                    });
            }, modal).finally(() => {
                // if we are opening then resolve it later, after its open
                if (!isOpening) {
                    resolve();
                }
            });
        });
    }

    /**
     * Returned promise is resolved after previous component has been opened or finished procesing
     */
    protected abstract listen(cb: (data?: D) => void, modal: NDfModal.IConfig): Promise<void>;

    protected open(modal: NDfModal.IConfig, variant?: string, data?: D): Promise<any> {
        return this.dfModalService.open(undefined, modal, variant, data);
    }
}
